import {Component, Inject, Input, LOCALE_ID, Renderer2} from '@angular/core';
import {AuthService} from "../../../common/modules/auth/services/auth.service";
import {hingeInFromTop, slideIn} from "../../../../base/animations/component.animation";
import {MENU, MenuGroup, MenuItem} from "./menu.model";
import {NavigationStart, Router} from "@angular/router";
import {Utility} from "../../../common/modules/utility/utility";
import {Locales, MenuTypeKey, MenuTypes} from "../../../../models/global.config";
import {LocalStorageService} from "../../../../base/services/storage/localstorage.service";
import {BUILD_INFO} from "../../../../../environments/build-info";

@Component({
  selector: 'admin-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss'],
  animations: [
    hingeInFromTop('expanded'),
    slideIn('slideIn', 'left'),
  ]
})
export class LeftNavComponent {

  isAdmin: boolean

  authorities: string[] = []

  isMenuCollapsed = false
  @Input() menu = MENU
  menuType: MenuTypes = MenuTypes.VERTICAL

  constructor(
    authService: AuthService,
    private renderer: Renderer2,
    private router: Router,
    @Inject(LOCALE_ID) protected locale: string
  ) {
    authService.isAdminAsync().subscribe(value => this.isAdmin = value)
    authService.getAuthoritiesAsync().subscribe(value => this.authorities = value)
    this.setActiveMenuItem(this.router.url)

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.setActiveMenuItem(event.url)
      }
    });

    LocalStorageService.retrieveAsync(MenuTypeKey.DASHBOARD, (mt) => {
      this.menuType = (mt as MenuTypes) || MenuTypes.VERTICAL
    })
  }

  showHorizontalMenu() {
    return this.menuType === MenuTypes.HORIZONTAL && !Utility.isTabletOrMobileScreen
  }

  toggleLeftMenu() {
    if (!Utility.isTabletOrMobileScreen) {
      return
    }
    const body = document.body;

    body.classList.toggle('sidebar-enable');
    if (window.innerWidth <= 992) {
      body.classList.toggle('vertical-collpsed');
      console.log(this.isMenuCollapsed)
      this.isMenuCollapsed = !this.isMenuCollapsed
      console.log(this.isMenuCollapsed)
    }

    if (body.classList.contains('vertical-collpsed')) {
      this.renderer.addClass(body, 'vertical-collpsed');
      this.isMenuCollapsed = true
    } else {
      this.renderer.removeClass(body, 'vertical-collpsed');
      this.isMenuCollapsed = false
    }
  }

  onMenuGroupClick(groupName: string) {
    this.menu = this.menu.map(g => {
      if (g.title == groupName) {
        g.expanded = !g.expanded
      } else {
        g.expanded = false
      }
      return g
    })

    // if (window.innerWidth <= 1280) {
    //   this.expandSidebar(true)
    // }
  }

  expandSidebar(expand: boolean) {
    const body = document.body;
    console.log(this.isMenuCollapsed)
    this.isMenuCollapsed = !expand
    console.log(this.isMenuCollapsed)
    if (!expand) {
      body.classList.add('sidebar-enable');
      body.classList.add('vertical-collpsed');
    } else {
      body.classList.remove('sidebar-enable');
      body.classList.remove('vertical-collpsed');
    }

    if (Utility.isTabletScreen && !this.isMenuCollapsed) {
      this.menu = this.menu.map(g => {
        g.expanded = true
        return g
      })
    }
  }


  private setActiveMenuItem(url: string) {
    this.menu = this.menu.map(g => {
      let items = g.items.map(i => {
        i.selected = url.includes(i.link)
        return i
      })
      g.items = items
      g.expanded = items.some(i => i.selected)
      return g
    })

    if (Utility.isTabletScreen) {
      this.expandSidebar(false)
    }
  }

  onMenuItemClick(item: MenuItem) {
    if (Utility.isMobileScreen) {
      this.toggleLeftMenu()
    }
    if (item.link.startsWith("http")) {
      window.open(item.link, '_blank')
    } else {
      this.router.navigateByUrl(item.link).then(r => {
      })
    }
  }

  hasPermission(item: MenuItem) {
    return this.isAdmin || item.permissions.some(p => this.authorities.includes(p))
  }

  shouldHide(group: MenuGroup) {
    return !group.items.some(i => this.hasPermission(i))
  }

  protected readonly Locales = Locales;
  protected readonly BUILD_INFO = BUILD_INFO;

  get buildInfoTitle(): string {
    return `version ${BUILD_INFO.version}\ncommit ${BUILD_INFO.commit}\nbranch ${BUILD_INFO.branch}\nbuilt ${BUILD_INFO.buildTime || 'dev'}`;
  }
}

